<template>
  <div class="Dialog rule" v-if="isShown">
    <div class="inner">
      <i class="close" @click="close"></i>
      <div class="title">活动规则</div>
      <div class="rule-con" v-if="userAgent.weixin && gameInfo.weixinrules"  v-html="gameInfo.weixinrules"></div>
      <div class="rule-con" v-else v-html="gameInfo.rules"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
import myMinin from "./mixin"
export default {
  name: "Rule",
  mixins: [myMinin],
  props: ["isShown", "maskHeight"],
  computed: {
    ...mapState(["gameInfo", "userAgent"]),
    ...mapGetters([""])
  },
  methods: {
    ...mapActions(["setMaskShowStatus"])
  }
}
</script>

<style scoped>
</style>
